export default async () => {
    const requestCallback = window.requestIdleCallback || window.setTimeout;

    await new Promise(resolve => requestCallback(() => resolve()));
};
